import { render, staticRenderFns } from "./EditSecondaryContentDialog.vue?vue&type=template&id=8cb7dd8c&"
import script from "./EditSecondaryContentDialog.vue?vue&type=script&lang=ts&"
export * from "./EditSecondaryContentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
